<template>
  <div>
    <el-card
      class="box-card"
      v-for="(d, idx) in dates"
      :key="idx"
      >
      <div slot="header" class="clearfix">
        {{ $t('api.branch.fields.prop.event_date.label') }}
      </div>
      <el-row :gutter="10">
        <el-col :span="6">
          <form-item
            name="date"
            :label="$t('api.branch.fields.prop.event_date.date.label')"
            >
            <el-date-picker
              v-model="d.date"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$t('api.branch.fields.prop.event_date.date.placeholder')"
              @change="updateDates"
              >
            </el-date-picker>
          </form-item>
        </el-col>
        <el-col :span="6">
          <std-opt
            v-model="d.type"
            :isForm="true"
            name="eventType"
            data="eventType"
            :onChange="updateDates"
            >
          </std-opt>
        </el-col>
        <el-col :span="12">
          <text-field
            v-model="d.number"
            base="branch"
            name="prop.event_date.number"
            @change="updateDates"
            >
          </text-field>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col>
          <text-field
            v-model="d.note"
            base="branch"
            name="prop.event_date.note"
            type="textarea"
            :autosize="{minRows:1,maxRows:3}"
            @change="updateDates"
            :rules="getNoteRules(d.type, idx)"
            >
          </text-field>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col>
          <form-item
            name="action"
            :hasLabel="false"
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              circle
              @click="addRow(idx)"
              >
            </el-button>
            <el-button
              v-if="dates.length > 1"
              type="danger"
              icon="el-icon-minus"
              circle
              @click="minusRow(idx)"
              >
            </el-button>
          </form-item>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>

import { getTransText } from '@/utils/i18n'

const defDates = {
  date: '',
  type: 0,
  note: '',
  number: ''
}

export default {
  name: 'event-date',
  props: {
    value: null
  },
  data () {
    return {
      dates: [
        Object.assign({}, defDates)
      ]
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    value (v) {
      this.dates.splice(0, this.dates.length)
      if (v) {
        let d = JSON.parse(v)
        if (d.length <= 0) {
          this.dates.push(Object.assign({}, defDates))
        } else {
          d.forEach((item, idx, array) => {
            this.dates.push(item)
          })
        }
      }
    }
  },
  methods: {
    getTransText,
    getNoteRules (type, idx) {
      return [{
        required: this.isNoteRequeired(type),
        validator: (rule, value, callback) => {
          this.validNotes(rule, value, callback, idx)
        },
        trigger: 'blur'
      }]
    },
    isNoteRequeired (type) {
      switch (type) {
        case 16: // short
        case 17: // event
        case 2: // term
        case 6: // nosale
        case 18: // nosaleTemp
          return true
      }
      return false
    },
    validNotes (rule, value, callback, idx) {
      let d = this.dates[idx]
      if (this.isNoteRequeired(d.type) &&
        (d.note === '' || d.note === null)
      ) {
        callback(new Error(
          this.getTransText('prop.event_date.note', 'error', 'branch')
        ))
        return
      }
      callback()
    },
    updateDates () {
      this.$emit('updateEventDate', this.dates)
    },
    addRow (idx) {
      let d = Object.assign({}, this.dates[idx])
      this.$set(d, 'number', '')
      this.$set(d, 'note', '')
      this.dates.splice(idx + 1, 0, d)
      this.updateDates()
    },
    minusRow (idx) {
      this.dates.splice(idx, 1)
      this.updateDates()
    }
  }
}
</script>
